const prefix = 'drivex/customers';

const LOAD_CUSTOMER_DETAILS_SUCCESS = `${prefix}/LOAD_CUSTOMER_DETAILS_SUCCESS`;
const LOAD_CUSTOMER_SUCCESS = `${prefix}/LOAD_CUSTOMER_SUCCESS`;

export default {
  LOAD_CUSTOMER_DETAILS_SUCCESS,
  LOAD_CUSTOMER_SUCCESS,
};
